import { checkIfIsDefaultPrivate } from "PFApp/activities/helpers";
import { Activity, Template } from "PFCore/types";

type GetPrivacyConfigurationParams = {
  template: Template;
  parentActivity?: Activity;
};

export const getPrivacyConfiguration = ({ template, parentActivity }: GetPrivacyConfigurationParams) => {
  const isForceVisibilitySet = !!template.force_visibility;
  const isForcePrivate = template.force_visibility === "private";
  const isDefaultPrivate = isForceVisibilitySet
    ? isForcePrivate
    : checkIfIsDefaultPrivate(template, parentActivity);

  return {
    isForceVisibilitySet,
    isForcePrivate,
    isDefaultPrivate
  };
};
